import React from 'react'
import { Text } from '@shopify/polaris'

const DashboardHeader = ({ user, t }) => {
	return (
		<Text variant='heading3xl' as='span'>
			{t("home.hello")}, {user.first_name || ""}
		</Text>
	)
}

export default DashboardHeader

